import { FsAdvancedMarker } from '@lib/geo/google/map';

import { SnLprRead } from '../../api/models';

export class FsLprReadAdvancedMarker extends FsAdvancedMarker {
  constructor(public readonly lprRead: SnLprRead) {
    super({
      position: new google.maps.LatLng(
        lprRead.geometry.coordinates[1],
        lprRead.geometry.coordinates[0],
      ),
      title: lprRead.id,
      content: document.createElement('div'),
      collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
    });
    const content: any = this.getMarker().content;
    content.classList.add('fs__lpr-read-advanced-marker');

    content.style.border = '2px solid #fff';
    content.innerHTML = '<img class="fs__lpr-read-icon" src="/assets/fusus-icons/PNG/car.png"/>';
  }
}
